module.exports = __webpack_public_path__ + "img/logo-white.52ae872c.svg";